import React, { FC, ReactElement } from "react"

import { useTranslation } from "react-i18next"

import { TopBar } from "components/navigation/TopBar"

import { AliasesConfig } from "features/postbacks/AliasesConfig"
import { PostbackList } from "features/postbacks/PostbackList"
import { PostbackLogs } from "features/postbacks/PostbackLogs"

export const S2SPostbacks: FC = (): ReactElement => {
  const { t } = useTranslation(["translation"], { useSuspense: false })

  return (
    <div className="grid w-full gap-8 p-8 pt-0 grid-col-1">
      <TopBar title={t("s2sPostbacks.title")} />
      <AliasesConfig />
      <PostbackList />
      <PostbackLogs />
    </div>
  )
}
